import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Options } from 'highcharts/highcharts';
import { Chart } from 'angular-highcharts';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
var Highcharts = require('highcharts/highcharts');

// Loading Pareto as a module
require('highcharts/modules/pareto')(Highcharts);

@Component({
  selector: 'app-dt-pareto-dashboard',
  templateUrl: './dt-pareto-dashboard.component.html',
  styleUrls: ['./dt-pareto-dashboard.component.scss'],
})
export class DtParetoDashboardComponent implements OnInit {
  ParetoAnalysisForm!: FormGroup;

  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  menuBlueIconUrl = 'assets/images/menu-bottom-blue-icon.png';

  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  ParetoDashboardData!: any;
  activeButton!: any;
  filteredGroups: any;
  filteredLines: any;
  filteredUnits: any;
  filteredPlants: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  categoryDDList!: any[];
  ReasonDDList!: any[];
  selectedCat!: any;
  labelReason1: any[] = new Array();
  dataReason1: any[] = new Array();
  labelReason2: any[] = new Array();
  dataReason2: any[] = new Array();
  labelReason3: any[] = new Array();
  dataReason3: any[] = new Array();
  labelReason4: any[] = new Array();
  dataReason4: any[] = new Array();
  labelFault: any[] = new Array();
  dataFault: any[] = new Array();
  faultList: any[] = new Array();
  faults: any[] = new Array();
  key!: any;
  window: any;
  childIndex: number = 0;
  breadcrumList: any = [];
  activeChipsCat!: {};
  activeChipsReason!: {};
  options!: Options;
  isClicked = true;
  selectedCategory!: string;
  isClickedReason1 = true;
  selectedReason1!: string;
  isClickedReason2 = true;
  selectedReason2!: string;
  isClickedReason3 = true;
  selectedReason3!: string;
  chartDTClassificationParetoAnalysis!: Chart;
  chartDTEquipmentParetoAnalysisReason1!: Chart;
  chartDTEquipmentParetoAnalysisReason2!: Chart;
  chartDTEquipmentParetoAnalysisReason3!: Chart;
  chartDTEquipmentParetoAnalysisReason4!: Chart;
  chartDTEquipmentParetoAnalysisFault!: Chart;
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
  };
  paginationPageSize: any = 10;
  rowData!: any[];
  ColumnDefs = [
    {
      field: 'FaultDesc',
      headerName: 'Fault Name',
      headerValueGetter: this.localizeHeader.bind(this),
    },
    {
      field: 'Start_Time',
      headerName: 'Start Time',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY hh:mm A')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this),
    },
    {
      field: 'End_Time',
      headerName: 'End Time',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY hh:mm A')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this),
    },
    {
      field: 'Duration',
      headerName: 'Duration(mins)',
      headerValueGetter: this.localizeHeader.bind(this),
    },
    {
      field: 'remark',
      headerName: 'Remark',
      headerValueGetter: this.localizeHeader.bind(this),
    }
  ];
  lang: any;
  languageDir = 'ltr';
  pageId: any;
  moduleId: any;
  langObj: any;
  hasQueryParams: boolean;
  firstRender: boolean = true;
  params: any;
  constructor(
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private kpiMaster: KpimasterService,
    private spinner: NgxSpinnerService,
    private productivityservice: ProductivityService,
    public router: Router,
    private commonService: CommonService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
  }

  ngOnInit(): void {
    localStorage.setItem('O3RightMenuId', '210')

    this.params = JSON.parse(localStorage.getItem('ParetoDashboard'));
    if (this.params) {
      this.hasQueryParams = true;
    }

    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
    localStorage.removeItem('ParetoDashboard');
  }

  GetMenuAccess() {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }

  initForm() {
    let dateStart, dateEnd;

    if (this.hasQueryParams && this.firstRender) {
      dateStart = this.params.dateStart;
      dateEnd = this.params.dateEnd;
    } else {
      dateStart = new Date();
      dateStart.setHours(6);
      dateStart.setMinutes(0);
      dateStart.setSeconds(0);

      dateEnd = new Date();
      // dateEnd.setDate(dateEnd.getDate());
    }

    this.ParetoAnalysisForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: [],
      searchval: [''],
    });
  }

  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangeLine(data: any): void {
    this.getUnit(data.value);
  }
  onChangePlant(data: any): void {
    this.getLine(data.value);
  }

  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;

          if (this.hasQueryParams && this.firstRender) {
            this.ParetoAnalysisForm.get('UserGroup1')?.setValue(
              parseInt(this.params.UserGroup1)
            );
          } else {
            this.ParetoAnalysisForm.patchValue({
              UserGroup1: data.lstEG[0].EG_Id,
              UserPlant1: data.lstEG[0].EG_Id,
            });
          }

          this.filteredGroups = this.GroupList.slice();
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: this.ParetoAnalysisForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;

          if (this.hasQueryParams && this.firstRender) {
            this.ParetoAnalysisForm.get('UserPlant1')?.patchValue(
              parseInt(this.params.UserPlant1)
            );
          } else {
            this.ParetoAnalysisForm.get('UserPlant1')?.patchValue(id);
          }
          this.filteredPlants = this.PlantList1.slice();
          this.getLine(id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLine(id: any) {
    const key = {
      PT_ID: this.ParetoAnalysisForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
          if (this.hasQueryParams && this.firstRender) {
            this.ParetoAnalysisForm.get('line')?.setValue(
              parseInt(this.params.line)
            );
          } else {
            this.ParetoAnalysisForm.controls.line.patchValue(lineDefault.PL_Id);
          }
          this.filteredLines = this.lineList.slice();
          this.getUnit(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnit(id: number) {
    const key = {
      PL_ID: this.ParetoAnalysisForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          const unitDefault = this.unitList[0];
          if (this.hasQueryParams && this.firstRender) {
            this.ParetoAnalysisForm.get('unit')?.setValue(
              parseInt(this.params.UnitId)
            );
          } else {
            this.ParetoAnalysisForm.controls.unit.patchValue(unitDefault.PU_Id);
          }
          this.firstRender = false;
          this.filteredUnits = this.unitList.slice();
        }
        this.onSubmit();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getFaultList() {
    let data = {
      PUId: this.ParetoAnalysisForm.controls.unit.value,
      Start_time: new Date(this.ParetoAnalysisForm.controls.dateStart.value),
      End_time: new Date(this.ParetoAnalysisForm.controls.dateEnd.value),
    };
    if (this.hasQueryParams && this.firstRender) {
      data = {
        PUId: this.params.unit,
        Start_time: new Date(this.params.dateStart),
        End_time: new Date(this.params.dateEnd),
      };
    }
    this.spinner.show();
    this.productivityservice.getFaultList(data).subscribe(
      (res: any) => {
        this.firstRender = false;
        this.faultList = res.listFault;
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
        console.log('err', err);
      }
    );
  }

  getOeeDashboard() {
    let data = {
      GroupId: this.ParetoAnalysisForm.controls.UserGroup1.value,
      PlantId: this.ParetoAnalysisForm.controls.UserPlant1.value,
      LineId: this.ParetoAnalysisForm.controls.line.value,
      UnitId: this.ParetoAnalysisForm.controls.unit.value,
      dtStartDate: new Date(this.ParetoAnalysisForm.controls.dateStart.value),
      dtEndDate: new Date(this.ParetoAnalysisForm.controls.dateEnd.value),
      shift: '*',
    };
    if (this.hasQueryParams && this.firstRender) {
      data = {
        GroupId: this.params.UserGroup1,
        PlantId: this.params.UserPlant1,
        LineId: this.params.line,
        UnitId: this.params.UnitId,
        dtStartDate: new Date(this.params.dateStart),
        dtEndDate: new Date(this.params.dateEnd),
        shift: '*',
      };
    }
    this.spinner.show();
    this.productivityservice.getDTParetoDashboard(data).subscribe(
      (res: any) => {
        this.ParetoDashboardData = res;
        this.setData();
        this.getFaultList();
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
        console.log('err', err);
      }
    );
  }

  onSubmit(): void {
    this.makeData();
    this.getOeeDashboard();
  }

  today(): void {
    this.makeDatatoDay();
    this.getOeeDashboard();
  }

  yesterday(): void {
    this.makeDataYesterDay();
    this.getOeeDashboard();
  }

  lastWeek(): void {
    this.makeDataLastWeek();
    this.getOeeDashboard();
  }

  lastMonth(): void {
    this.makeDataLastMonth();
    this.getOeeDashboard();
  }

  showPhase(event: any) {
    this.activeButton = event;
  }

  setData() {
    this.categoryDDList = [];
    let setCategory = new Set();
    this.ParetoDashboardData.dtDrillDownChartData?.forEach((e: any) => {
      if (
        e.Category === 'Planned Downtime' ||
        e.Category === 'UnPlanned Downtime'
      ) {
        // setCategory.add("All");
        setCategory.add(e.Category);
      }
    });
    setCategory.forEach((element: any) => {
      this.categoryDDList.push({
        ERC_Desc: element.split('.')[element.split('.').length - 1],
      });
    });

    this.drawDTClassificationParetoAnalysis();
    this.getReason1OnLoad();
    // this.getReason2OnLoad();
    // this.getReason3OnLoad();
    this.getFaultOnLoad();
  }

  setOnReason1Clicked() {
    // this.getReason2OnLoad();
    // this.getReason3OnLoad();
    this.getFaultOnLoad();
  }

  // setOnReason2Clicked(){
  //   this.getReason3OnLoad();
  //   this.getFaultOnLoad();
  // }
  // setOnReason3Clicked(){
  //   this.getFaultOnLoad();
  // }

  makeData() {
    const startDt = this.dateAsYYYYMMDDHHNNSS(
      this.ParetoAnalysisForm.value.dateStart
    );
    const endDt = this.dateAsYYYYMMDDHHNNSS(
      this.ParetoAnalysisForm.value.dateEnd
    );

    this.key = {
      dtStartDate: startDt,
      dtEndDate: endDt,
      GroupId: this.ParetoAnalysisForm.value.UserGroup1,
      PlantId: this.ParetoAnalysisForm.value.DepartmentList,
      UnitId: this.ParetoAnalysisForm.value.unit,
      LineId: this.ParetoAnalysisForm.value.line,
      shift: '*',
    };
  }

  makeDatatoDay() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    const startDt = this.dateAsYYYYMMDDHHNNSS(stDT);
    const endDt = this.dateAsYYYYMMDDHHNNSS(edDT);
    this.ParetoAnalysisForm.get('dateStart')?.patchValue(stDT);
    this.ParetoAnalysisForm.get('dateEnd')?.patchValue(edDT);
    this.key = {
      dtStartDate: startDt,
      dtEndDate: endDt,
      GroupId: this.ParetoAnalysisForm.value.UserGroup1,
      PlantId: this.ParetoAnalysisForm.value.DepartmentList,
      UnitId: this.ParetoAnalysisForm.value.unit,
      LineId: this.ParetoAnalysisForm.value.line,
      shift: '*',
    };
  }

  makeDataYesterDay() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    const startDt = this.dateAsYYYYMMDDHHNNSS(stDT);
    const endDt = this.dateAsYYYYMMDDHHNNSS(edDT);
    this.ParetoAnalysisForm.get('dateStart')?.patchValue(stDT);
    this.ParetoAnalysisForm.get('dateEnd')?.patchValue(edDT);
    this.key = {
      dtStartDate: startDt,
      dtEndDate: endDt,
      GroupId: this.ParetoAnalysisForm.value.UserGroup1,
      PlantId: this.ParetoAnalysisForm.value.DepartmentList,
      UnitId: this.ParetoAnalysisForm.value.unit,
      LineId: this.ParetoAnalysisForm.value.line,
      shift: '*',
    };
  }

  makeDataLastWeek() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    const startDt = this.dateAsYYYYMMDDHHNNSS(stDT);
    const endDt = this.dateAsYYYYMMDDHHNNSS(edDT);
    this.ParetoAnalysisForm.get('dateStart')?.patchValue(stDT);
    this.ParetoAnalysisForm.get('dateEnd')?.patchValue(edDT);
    this.key = {
      dtStartDate: startDt,
      dtEndDate: endDt,
      GroupId: this.ParetoAnalysisForm.value.UserGroup1,
      PlantId: this.ParetoAnalysisForm.value.DepartmentList,
      UnitId: this.ParetoAnalysisForm.value.unit,
      LineId: this.ParetoAnalysisForm.value.line,
      shift: '*',
    };
  }

  makeDataLastMonth() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 30);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    const startDt = this.dateAsYYYYMMDDHHNNSS(stDT);
    const endDt = this.dateAsYYYYMMDDHHNNSS(edDT);
    this.ParetoAnalysisForm.get('dateStart')?.patchValue(stDT);
    this.ParetoAnalysisForm.get('dateEnd')?.patchValue(edDT);
    this.key = {
      dtStartDate: startDt,
      dtEndDate: endDt,
      GroupId: this.ParetoAnalysisForm.value.UserGroup1,
      PlantId: this.ParetoAnalysisForm.value.DepartmentList,
      UnitId: this.ParetoAnalysisForm.value.unit,
      LineId: this.ParetoAnalysisForm.value.line,
      shift: '*',
    };
  }

  //date formatter
  dateAsYYYYMMDDHHNNSS(date: any): string {
    date = new Date(date);
    return (
      date.getFullYear() +
      '-' +
      this.leftpad(date.getMonth() + 1, 2) +
      '-' +
      this.leftpad(date.getDate(), 2) +
      ' ' +
      this.leftpad(date.getHours(), 2) +
      ':' +
      this.leftpad(date.getMinutes(), 2) +
      ':' +
      this.leftpad(date.getSeconds(), 2)
    );
  }
  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  // =============================================Charts=========================================================//
  drawDTClassificationParetoAnalysis() {
    let dtLabel: any[] = new Array();
    let dataSeries: any[] = new Array();
    let data = this.getData('category', 'all');
    data.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    data.forEach((e: any) => {
      dtLabel.push(e.name.split('.')[e.name.split('.').length - 1]);
      dataSeries.push(e.value);
    });

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      tooltip: {
        shared: true,
        valueDecimals: 2,
      },
      xAxis: {
        categories: dtLabel,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: {
            text: '',
          },
        },
        {
          title: {
            text: '',
          },
          minPadding: 0,
          maxPadding: 0,
          max: 100,
          min: 0,
          opposite: true,
          labels: {
            format: '{value}%',
          },
        },
      ],
      plotOptions: {
        series: {
          cursor: 'pointer',

          point: {
            events: {
              click: this.clickedCategory.bind(this),
            },
          },
        },
      },
      series: [
        {
          type: 'pareto',
          name: 'Running Total %',
          yAxis: 1,
          zIndex: 10,
          color: '#f7c845',
          baseSeries: 1,
          tooltip: {
            valueDecimals: 2,
            valueSuffix: '%',
          },
        },
        {
          name: 'Duration(mins)',
          type: 'column',
          color: 'blue',
          zIndex: 2,
          data: dataSeries,
          states: {
            select: {
              color: 'green',
            },
          },
          allowPointSelect: true,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartDTClassificationParetoAnalysis = chart;
  }
  drawDTEquipmentParetoAnalysis() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      tooltip: {
        shared: true,
        valueDecimals: 2,
      },
      xAxis: {
        categories: this.labelReason1,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: {
            text: '',
          },
        },
        {
          title: {
            text: '',
          },
          minPadding: 0,
          maxPadding: 0,
          max: 100,
          min: 0,
          opposite: true,
          labels: {
            format: '{value}%',
          },
        },
      ],
      plotOptions: {
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: this.clickedReason1.bind(this),
            },
          },
        },
      },
      series: [
        {
          type: 'pareto',
          name: 'Running Total %',
          yAxis: 1,
          zIndex: 10,
          color: '#f7c845',
          baseSeries: 1,
          tooltip: {
            valueDecimals: 2,
            valueSuffix: '%',
          },
        },
        {
          name: 'Duration(mins)',
          type: 'column',
          color: 'blue',
          zIndex: 2,
          data: this.dataReason1,
          states: {
            select: {
              color: 'green',
            },
          },
          allowPointSelect: true,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartDTEquipmentParetoAnalysisReason1 = chart;
  }
  // drawDTReasonParetoAnalysisReason2() {
  //   this.options = {
  //     chart: {
  //       type: 'column'
  //     },
  //     title: {
  //       text: ''
  //     },
  //     tooltip: {
  //       shared: true,
  //       valueDecimals: 2
  //     },
  //     xAxis: {
  //       categories: this.labelReason2,
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     yAxis: [{
  //       title: {
  //         text: ''
  //       }
  //     }, {
  //       title: {
  //         text: ''
  //       },
  //       minPadding: 0,
  //       maxPadding: 0,
  //       max: 100,
  //       min: 0,
  //       opposite: true,
  //       labels: {
  //         format: "{value}%"
  //       }
  //     }],
  //     plotOptions: {
  //       series: {
  //         cursor: 'pointer',
  //         point: {
  //           events: {
  //             click: this.clickedReason2.bind(this)
  //           }
  //         }
  //       }
  //     },
  //     series: [{
  //       type: 'pareto',
  //       name: 'Running Total %',
  //       yAxis: 1,
  //       zIndex: 10,
  //       color: '#f7c845',
  //       baseSeries: 1,
  //       tooltip: {
  //         valueDecimals: 2,
  //         valueSuffix: '%'
  //       }
  //     }, {
  //       name: 'Duration(mins)',
  //       type: 'column',
  //       color: 'blue',
  //       zIndex: 2,
  //       data: this.dataReason2,
  //       states: {
  //         select: {
  //           color: 'green'
  //         }
  //       },
  //       allowPointSelect: true
  //     }]

  //   }
  //   let chart = new Chart(this.options);
  //   this.chartDTEquipmentParetoAnalysisReason2 = chart;
  // }
  // drawDTReasonParetoAnalysisReason3() {
  //   this.options = {
  //     chart: {
  //       type: 'column'
  //     },
  //     title: {
  //       text: ''
  //     },
  //     tooltip: {
  //       shared: true,
  //       valueDecimals: 2
  //     },
  //     xAxis: {
  //       categories: this.labelReason3,
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     yAxis: [{
  //       title: {
  //         text: ''
  //       }
  //     }, {
  //       title: {
  //         text: ''
  //       },
  //       minPadding: 0,
  //       maxPadding: 0,
  //       max: 100,
  //       min: 0,
  //       opposite: true,
  //       labels: {
  //         format: "{value}%"
  //       }
  //     }],
  //     plotOptions: {
  //       series: {
  //         cursor: 'pointer',
  //         point: {
  //           events: {
  //             click: this.clickedReason3.bind(this)
  //           }
  //         }
  //       }
  //     },
  //     series: [{
  //       type: 'pareto',
  //       name: 'Running Total %',
  //       yAxis: 1,
  //       zIndex: 10,
  //       color: '#f7c845',
  //       baseSeries: 1,
  //       tooltip: {
  //         valueDecimals: 2,
  //         valueSuffix: '%'
  //       }
  //     }, {
  //       name: 'Duration(mins)',
  //       type: 'column',
  //       color: 'blue',
  //       zIndex: 2,
  //       data: this.dataReason3,
  //       states: {
  //         select: {
  //           color: 'green'
  //         }
  //       },
  //       allowPointSelect: true
  //     }]

  //   }
  //   let chart = new Chart(this.options);
  //   this.chartDTEquipmentParetoAnalysisReason3 = chart;
  // }
  //   drawDTReasonParetoAnalysisReason4() {
  //     this.options = {
  //       chart: {
  //         type: 'column'
  //     },
  //     title:{
  //       text:''
  //     },
  //     tooltip: {
  //       shared: true,
  //       valueDecimals:2
  //   },
  //   xAxis: {
  //       categories:this.labelReason4,
  //   },
  //   credits:{
  //     enabled:false
  //   },
  //   yAxis: [{
  //       title: {
  //           text: ''
  //       }
  //   }, {
  //       title: {
  //           text: ''
  //       },
  //       minPadding: 0,
  //       maxPadding: 0,
  //       max: 100,
  //       min: 0,
  //       opposite: true,
  //       labels: {
  //           format: "{value}%"
  //       }
  //   }],
  //   plotOptions: {
  //     series: {
  //         cursor: 'pointer',
  //         point: {
  //             events: {
  //                 click:  this.getFault.bind(this)
  //             }
  //         }
  //     }
  // },
  //   series: [{
  //       type: 'pareto',
  //       name: 'Pareto',
  //       yAxis: 1,
  //       zIndex: 10,
  //       color:'#f7c845',
  //       baseSeries: 1,
  //       tooltip: {
  //           valueDecimals: 2,
  //           valueSuffix: '%'
  //       }
  //   }, {
  //       name: 'Minutes',
  //       type: 'column',
  //       color:'blue',
  //       zIndex: 2,
  //       data: this.dataReason4,
  //       states: {
  //         select: {
  //             color: 'green'
  //           }
  //       },
  //       allowPointSelect: true
  //   }]

  //   }
  //     let chart = new Chart(this.options);
  //     this.chartDTEquipmentParetoAnalysisReason4 = chart;
  //   }

  drawDTFaultParetoAnalysis() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      tooltip: {
        shared: true,
        valueDecimals: 2,
      },
      xAxis: {
        categories: this.labelFault,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: {
            text: '',
          },
        },
        {
          title: {
            text: '',
          },
          minPadding: 0,
          maxPadding: 0,
          max: 100,
          min: 0,
          opposite: true,
          labels: {
            format: '{value}%',
          },
        },
      ],
      plotOptions: {
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: this.clickedFault.bind(this),
            },
          },
        },
      },
      series: [
        {
          type: 'pareto',
          name: 'Running Total %',
          yAxis: 1,
          zIndex: 10,
          color: '#f7c845',
          baseSeries: 1,
          tooltip: {
            valueDecimals: 2,
            valueSuffix: '%',
          },
        },
        {
          name: 'Duration(mins)',
          type: 'column',
          color: 'blue',
          zIndex: 2,
          data: this.dataFault,
          states: {
            select: {
              color: 'green',
            },
          },
          allowPointSelect: true,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartDTEquipmentParetoAnalysisFault = chart;
  }

  getData(value: string, cat: string): any {
    var resMap = new Map();
    let data: any[] = new Array();
    if (value === 'category') {
      this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
        if (
          x.Category.toLowerCase() === 'planned downtime' ||
          x.Category.toLowerCase() === 'unplanned downtime' ||
          x.Category.toLowerCase() === 'totalshutdown'
        )
          if (!resMap.has(x.Category)) resMap.set(x.Category, x.Value);
          else resMap.set(x.Category, x.Value + resMap.get(x.Category));
      });
      resMap.forEach((value, key) => {
        data.push({
          name: key,
          value: value,
        });
      });
      return data;
    }
  }

  getReason1OnLoad() {
    var resMap = new Map();
    let data: any[] = new Array();
    this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
      if (
        this.selectedCat !== undefined
          ? this.selectedCat ===
          x.Category.split('.')[x.Category.split('.').length - 1]
          : x.Main !== 'Performance Loss' && x.Main !== 'Quality Loss'
      ) {
        if (!resMap.has(x.Reson)) resMap.set(x.Reson, x.Value);
        else resMap.set(x.Reson, x.Value + resMap.get(x.Reson));
      }
    });
    resMap.forEach((value, key) => {
      data.push({
        name: key,
        value: value,
      });
    });
    this.labelReason1 = [];
    this.dataReason1 = [];
    data?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    data?.forEach((e: any) => {
      this.labelReason1.push(e.name.split('.')[e.name.split('.').length - 1]);
      this.dataReason1.push(e.value);
    });
    this.drawDTEquipmentParetoAnalysis();
  }

  // getReason2OnLoad() {
  //   var resMap = new Map();
  //   let data: any[] = new Array();
  //   var resMapConsol = new Map();
  //   let dataConsole: any[] = new Array();
  //   this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
  //     if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] : x.Main !== 'Performance Loss' && x.Main !== 'Quality Loss') {
  //       if (!resMap.has(x.Reson2))
  //         resMap.set(x.Reson2, x.Value);
  //       else
  //         resMap.set(x.Reson2, (x.Value + resMap.get(x.Reson2)));
  //     }
  //   })
  //   resMap.forEach((value, key) => {
  //     data.push({
  //       name: key.split('.')[key.split('.').length - 1],
  //       value: value
  //     });
  //   })

  //   data?.map((x: any) => {
  //     if (!resMapConsol.has(x.name))
  //       resMapConsol.set(x.name, x.value);
  //     else
  //       resMapConsol.set(x.name, (x.value + resMapConsol.get(x.name)));
  //   })
  //   resMapConsol.forEach((value, key) => {
  //     dataConsole.push({
  //       name: key,
  //       value: value
  //     });
  //   })
  //   this.labelReason2 = [];
  //   this.dataReason2 = [];
  //   dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
  //   dataConsole?.forEach((e: any) => {
  //     this.labelReason2.push(e.name);
  //     this.dataReason2.push(e.value);
  //   });
  //   this.drawDTReasonParetoAnalysisReason2();
  // }

  // getReason3OnLoad() {
  //   var resMap = new Map();
  //   let data: any[] = new Array();
  //   var resMapConsol = new Map();
  //   let dataConsole: any[] = new Array();
  //   this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
  //     if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] : x.Main !== 'Performance Loss' && x.Main !== 'Quality Loss') {
  //       if (!resMap.has(x.Reson3))
  //         resMap.set(x.Reson3, x.Value);
  //       else
  //         resMap.set(x.Reson3, (x.Value + resMap.get(x.Reson3)));
  //     }
  //   })
  //   resMap.forEach((value, key) => {
  //     data.push({
  //       name: key.split('.')[key.split('.').length - 1],
  //       value: value
  //     });
  //   })

  //   data?.map((x: any) => {
  //     if (!resMapConsol.has(x.name))
  //       resMapConsol.set(x.name, x.value);
  //     else
  //       resMapConsol.set(x.name, (x.value + resMapConsol.get(x.name)));
  //   })
  //   resMapConsol.forEach((value, key) => {
  //     dataConsole.push({
  //       name: key,
  //       value: value
  //     });
  //   })
  //   this.labelReason3 = [];
  //   this.dataReason3 = [];
  //   dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
  //   dataConsole?.forEach((e: any) => {
  //     this.labelReason3.push(e.name);
  //     this.dataReason3.push(e.value);
  //   });
  //   this.drawDTReasonParetoAnalysisReason3();
  // }

  getFaultOnLoad() {
    var resMap = new Map();
    let data: any[] = new Array();
    var resMapConsol = new Map();
    let dataConsole: any[] = new Array();
    this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
      if (
        this.selectedCat !== undefined
          ? this.selectedCat ===
          x.Category.split('.')[x.Category.split('.').length - 1]
          : x.Main !== 'Performance Loss' && x.Main !== 'Quality Loss'
      ) {
        if (!resMap.has(x.Fault)) resMap.set(x.Fault, x.Value);
        else resMap.set(x.Fault, x.Value + resMap.get(x.Fault));
      }
    });
    resMap.forEach((value, key) => {
      data.push({
        name: key.split('.')[key.split('.').length - 1],
        value: value,
      });
    });
    data?.map((x: any) => {
      if (!resMapConsol.has(x.name)) resMapConsol.set(x.name, x.value);
      else resMapConsol.set(x.name, x.value + resMapConsol.get(x.name));
    });
    resMapConsol.forEach((value, key) => {
      dataConsole.push({
        name: key,
        value: value,
      });
    });
    this.labelFault = [];
    this.dataFault = [];
    dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    dataConsole?.forEach((e: any) => {
      this.labelFault.push(e.name);
      this.dataFault.push(e.value);
    });
    this.drawDTFaultParetoAnalysis();
  }

  clickedCategory(value: any) {
    if (this.isClicked) {
      this.getAllOnCategory(value);
      this.isClicked = false;
      this.selectedCategory = value.point.category;
    } else if (this.selectedCategory !== value.point.category) {
      this.getAllOnCategory(value);
      this.isClicked = false;
      this.selectedCategory = value.point.category;
    } else {
      this.isClicked = true;
      this.selectedCat = undefined;
      this.setData();
    }
  }

  getAllOnCategory(value: any): void {
    this.labelReason2 = [];
    this.dataReason2 = [];
    this.labelReason3 = [];
    this.dataReason3 = [];
    this.labelReason4 = [];
    this.dataReason4 = [];
    this.labelFault = [];
    this.dataFault = [];
    this.selectedCat = value.point.category;
    //this.drawDTReasonParetoAnalysisReason2();
    //this.drawDTReasonParetoAnalysisReason3();
    this.drawDTFaultParetoAnalysis();
    var resMap = new Map();
    let data: any[] = new Array();
    var resMapConsol = new Map();
    let dataConsole: any[] = new Array();
    //=========================== Get Reason 1 ======================//
    this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
      if (
        x.Category.split('.')[x.Category.split('.').length - 1] ===
        value.point.category
      ) {
        if (!resMap.has(x.Reson)) resMap.set(x.Reson, x.Value);
        else resMap.set(x.Reson, x.Value + resMap.get(x.Reson));
      }
    });
    resMap.forEach((val, key) => {
      data.push({
        name: key,
        value: val,
      });
    });
    this.labelReason1 = [];
    this.dataReason1 = [];
    data?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    data?.forEach((e: any) => {
      this.labelReason1.push(e.name.split('.')[e.name.split('.').length - 1]);
      this.dataReason1.push(e.value);
    });
    this.drawDTEquipmentParetoAnalysis();

    //============================== Get Reason 2 ====================================//
    // var resMap2 = new Map();
    // let data2: any[] = new Array();
    // this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
    //   if (x.Category.split('.')[x.Category.split('.').length - 1] === value.point.category) {
    //     if (!resMap2.has(x.Reson2))
    //       resMap2.set(x.Reson2, x.Value);
    //     else
    //       resMap2.set(x.Reson2, (x.Value + resMap2.get(x.Reson2)));
    //   }
    // })
    // resMap2.forEach((value, key) => {
    //   data2.push({
    //     name: key.split('.')[key.split('.').length - 1],
    //     value: value
    //   });
    // })
    // data2?.map((x: any) => {
    //   if (!resMapConsol.has(x.name))
    //     resMapConsol.set(x.name, x.value);
    //   else
    //     resMapConsol.set(x.name, (x.value + resMapConsol.get(x.name)));
    // })
    // resMapConsol.forEach((value, key) => {
    //   dataConsole.push({
    //     name: key,
    //     value: value
    //   });
    // })
    // this.labelReason2 = [];
    // this.dataReason2 = [];
    // dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    // dataConsole?.forEach((e: any) => {
    //   this.labelReason2.push(e.name);
    //   this.dataReason2.push(e.value);
    // });
    // this.drawDTReasonParetoAnalysisReason2();

    // //=========================== Get Reason 3 ========================================//
    // var resMap3 = new Map();
    // let data3: any[] = new Array();
    // var resMapConsol3 = new Map();
    // let dataConsole3: any[] = new Array();
    // this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
    //   if (x.Category.split('.')[x.Category.split('.').length - 1] === value.point.category) {
    //     if (!resMap3.has(x.Reson3))
    //       resMap3.set(x.Reson3, x.Value);
    //     else
    //       resMap3.set(x.Reson3, (x.Value + resMap3.get(x.Reson3)));
    //   }
    // })
    // resMap3.forEach((value, key) => {
    //   data3.push({
    //     name: key.split('.')[key.split('.').length - 1],
    //     value: value
    //   });
    // })
    // data3?.map((x: any) => {
    //   if (!resMapConsol3.has(x.name))
    //     resMapConsol3.set(x.name, x.value);
    //   else
    //     resMapConsol3.set(x.name, (x.value + resMapConsol3.get(x.name)));
    // })
    // resMapConsol3.forEach((value, key) => {
    //   dataConsole3.push({
    //     name: key,
    //     value: value
    //   });
    // })
    // this.labelReason3 = [];
    // this.dataReason3 = [];
    // dataConsole3?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    // dataConsole3?.forEach((e: any) => {
    //   this.labelReason3.push(e.name);
    //   this.dataReason3.push(e.value);
    // });
    // this.drawDTReasonParetoAnalysisReason3();

    //===================================== Get Fault ==================================//
    var resMapFault = new Map();
    let dataFault: any[] = new Array();
    var resMapConsolFault = new Map();
    let dataConsoleFault: any[] = new Array();
    this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
      if (
        x.Category.split('.')[x.Category.split('.').length - 1] ===
        value.point.category
      ) {
        if (!resMapFault.has(x.Fault)) resMapFault.set(x.Fault, x.Value);
        else resMapFault.set(x.Fault, x.Value + resMapFault.get(x.Fault));
      }
    });
    resMapFault.forEach((value, key) => {
      dataFault.push({
        name: key.split('.')[key.split('.').length - 1],
        value: value,
      });
    });
    dataFault?.map((x: any) => {
      if (!resMapConsolFault.has(x.name))
        resMapConsolFault.set(x.name, x.value);
      else
        resMapConsolFault.set(x.name, x.value + resMapConsolFault.get(x.name));
    });
    resMapConsolFault.forEach((value, key) => {
      dataConsoleFault.push({
        name: key,
        value: value,
      });
    });
    this.labelFault = [];
    this.dataFault = [];
    dataConsoleFault?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    dataConsoleFault?.forEach((e: any) => {
      this.labelFault.push(e.name);
      this.dataFault.push(e.value);
    });
    this.drawDTFaultParetoAnalysis();
    this.isClicked = false;
    this.selectedCategory = value.point.category;
  }

  clickedReason1(value: any) {
    this.rowData = [];
    if (this.isClickedReason1) {
      this.getAllOnReason1(value);
      this.isClickedReason1 = false;
      this.selectedReason1 = value.point.category;
    } else if (this.selectedReason1 !== value.point.category) {
      this.getAllOnReason1(value);
      this.isClickedReason1 = false;
      this.selectedReason1 = value.point.category;
    } else {
      this.isClickedReason1 = true;
      this.setOnReason1Clicked();
    }
  }

  getAllOnReason1(value: any): void {
    this.labelReason3 = [];
    this.dataReason3 = [];
    this.labelReason4 = [];
    this.dataReason4 = [];
    this.labelFault = [];
    this.dataFault = [];
    //this.drawDTReasonParetoAnalysisReason3();
    this.drawDTFaultParetoAnalysis();
    var resMapConsol = new Map();
    let dataConsole: any[] = new Array();

    //============================== Get Reason 2 ====================================//
    // var resMap2 = new Map();
    // let data2: any[] = new Array();
    // this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
    //   if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] && value.point.category === x.Reson.split('.')[x.Reson.split('.').length - 1] : value.point.category === x.Reson.split('.')[x.Reson.split('.').length - 1]) {
    //     if (!resMap2.has(x.Reson2))
    //       resMap2.set(x.Reson2, x.Value);
    //     else
    //       resMap2.set(x.Reson2, (x.Value + resMap2.get(x.Reson2)));
    //   }
    // })
    // resMap2.forEach((value, key) => {
    //   data2.push({
    //     name: key.split('.')[key.split('.').length - 1],
    //     value: value
    //   });
    // })
    // data2?.map((x: any) => {
    //   if (!resMapConsol.has(x.name))
    //     resMapConsol.set(x.name, x.value);
    //   else
    //     resMapConsol.set(x.name, (x.value + resMapConsol.get(x.name)));
    // })
    // resMapConsol.forEach((value, key) => {
    //   dataConsole.push({
    //     name: key,
    //     value: value
    //   });
    // })
    // this.labelReason2 = [];
    // this.dataReason2 = [];
    // dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    // dataConsole?.forEach((e: any) => {
    //   this.labelReason2.push(e.name);
    //   this.dataReason2.push(e.value);
    // });
    // this.drawDTReasonParetoAnalysisReason2();

    // //=========================== Get Reason 3 ========================================//
    // var resMap3 = new Map();
    // let data3: any[] = new Array();
    // var resMapConsole3 = new Map();
    // let dataConsole3: any[] = new Array();
    // this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
    //   if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] && value.point.category === x.Reson.split('.')[x.Reson.split('.').length - 1] : value.point.category === x.Reson.split('.')[x.Reson.split('.').length - 1]) {
    //     if (!resMap3.has(x.Reson3))
    //       resMap3.set(x.Reson3, x.Value);
    //     else
    //       resMap3.set(x.Reson3, (x.Value + resMap3.get(x.Reson3)));
    //   }
    // })
    // resMap3.forEach((value, key) => {
    //   data3.push({
    //     name: key.split('.')[key.split('.').length - 1],
    //     value: value
    //   });
    // })
    // data3?.map((x: any) => {
    //   if (!resMapConsole3.has(x.name))
    //   resMapConsole3.set(x.name, x.value);
    //   else
    //   resMapConsole3.set(x.name, (x.value + resMapConsole3.get(x.name)));
    // })
    // resMapConsole3.forEach((value, key) => {
    //   dataConsole3.push({
    //     name: key,
    //     value: value
    //   });
    // })
    // this.labelReason3 = [];
    // this.dataReason3 = [];
    // dataConsole3?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    // dataConsole3?.forEach((e: any) => {
    //   this.labelReason3.push(e.name.split('.')[e.name.split('.').length - 1]);
    //   this.dataReason3.push(e.value);
    // });
    // this.drawDTReasonParetoAnalysisReason3();

    //===================================== Get Fault ==================================//
    var resMapFault = new Map();
    let dataFault: any[] = new Array();
    this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
      if (
        this.selectedCat !== undefined
          ? this.selectedCat ===
          x.Category.split('.')[x.Category.split('.').length - 1] &&
          value.point.category ===
          x.Reson.split('.')[x.Reson.split('.').length - 1]
          : value.point.category ===
          x.Reson.split('.')[x.Reson.split('.').length - 1]
      ) {
        if (!resMapFault.has(x.Fault)) resMapFault.set(x.Fault, x.Value);
        else resMapFault.set(x.Fault, x.Value + resMapFault.get(x.Fault));
      }
    });
    resMapFault.forEach((value, key) => {
      dataFault.push({
        name: key,
        value: value,
      });
    });
    this.labelFault = [];
    this.dataFault = [];
    dataFault?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
    dataFault?.forEach((e: any) => {
      this.labelFault.push(e.name.split('.')[e.name.split('.').length - 1]);
      this.dataFault.push(e.value);
    });
    this.drawDTFaultParetoAnalysis();
    this.isClickedReason1 = false;
    this.selectedReason1 = value.point.category;
  }

  // clickedReason2(value: any) {
  //   this.rowData = [];
  //   if (this.isClickedReason2) {
  //     this.getAllOnReason2(value);
  //     this.isClickedReason2 = false;
  //     this.selectedReason2 = value.point.category;
  //   } else if (this.selectedReason2 !== value.point.category) {
  //     this.getAllOnReason2(value);
  //     this.isClickedReason2 = false;
  //     this.selectedReason2 = value.point.category;
  //   } else {
  //     this.isClickedReason2 = true;
  //     this.setOnReason2Clicked();
  //   }
  // }

  // getAllOnReason2(value: any): void {
  //   this.labelReason4 = [];
  //   this.dataReason4 = [];
  //   this.labelFault = [];
  //   this.dataFault = [];
  //   this.drawDTFaultParetoAnalysis();
  //   var resMap = new Map();
  //   let data: any[] = new Array();
  //   var resMapConsol = new Map();
  //   let dataConsole: any[] = new Array();
  //   this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
  //     if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] && value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] :
  //     this.selectedReason1 !== undefined ?  this.selectedReason1 === x.Reson.split('.')[x.Reson.split('.').length - 1] && value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] : value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] ) {
  //       if (!resMap.has(x.Reson3))
  //         resMap.set(x.Reson3, x.Value);
  //       else
  //         resMap.set(x.Reson3, (x.Value + resMap.get(x.Reson3)));
  //     }
  //   })
  //   resMap.forEach((value, key) => {
  //     data.push({
  //       name: key.split('.')[key.split('.').length - 1],
  //       value: value
  //     });
  //   })
  //   data?.map((x: any) => {
  //     if (!resMapConsol.has(x.name))
  //       resMapConsol.set(x.name, x.value);
  //     else
  //       resMapConsol.set(x.name, (x.value + resMapConsol.get(x.name)));
  //   })
  //   resMapConsol.forEach((value, key) => {
  //     dataConsole.push({
  //       name: key,
  //       value: value
  //     });
  //   })
  //   this.labelReason3 = [];
  //   this.dataReason3 = [];
  //   dataConsole?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
  //   dataConsole?.forEach((e: any) => {
  //     this.labelReason3.push(e.name);
  //     this.dataReason3.push(e.value);
  //   });
  //   this.drawDTReasonParetoAnalysisReason3();

  //   //===================================== Get Fault ==================================//
  //   var resMapFault = new Map();
  //   let dataFault: any[] = new Array();
  //   this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
  //     if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] && value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] :
  //     this.selectedReason1 !== undefined ?  this.selectedReason1 === x.Reson.split('.')[x.Reson.split('.').length - 1] && value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] : value.point.category === x.Reson2.split('.')[x.Reson2.split('.').length - 1] ) {
  //       if (!resMapFault.has(x.Fault))
  //         resMapFault.set(x.Fault, x.Value);
  //       else
  //         resMapFault.set(x.Fault, (x.Value + resMapFault.get(x.Fault)));
  //     }
  //   })
  //   resMapFault.forEach((value, key) => {
  //     dataFault.push({
  //       name: key,
  //       value: value
  //     });
  //   })
  //   this.labelFault = [];
  //   this.dataFault = [];
  //   dataFault?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
  //   dataFault?.forEach((e: any) => {
  //     this.labelFault.push(e.name.split('.')[e.name.split('.').length - 1]);
  //     this.dataFault.push(e.value);
  //   });
  //   this.drawDTFaultParetoAnalysis();
  //   this.isClickedReason2 = false;
  //   this.selectedReason2 = value.point.category;
  // }

  // clickedReason3(value: any) {
  //   this.rowData = [];
  //   if (this.isClickedReason3) {
  //     this.getAllOnReason3(value);
  //     this.isClickedReason3 = false;
  //     this.selectedReason3 = value.point.category;
  //   } else if (this.selectedReason3 !== value.point.category) {
  //     this.getAllOnReason3(value);
  //     this.isClickedReason3 = false;
  //     this.selectedReason3 = value.point.category;
  //   } else {
  //     this.isClickedReason3 = true;
  //     this.setOnReason3Clicked();
  //   }
  // }

  // getAllOnReason3(value: any): void {
  //   var resMap = new Map();
  //   let data: any[] = new Array();
  //   this.ParetoDashboardData.dtDrillDownChartData?.map((x: any) => {
  //     if (this.selectedCat !== undefined ? this.selectedCat === x.Category.split('.')[x.Category.split('.').length - 1] && value.point.category === x.Reson3.split('.')[x.Reson3.split('.').length - 1]
  //     :  this.selectedReason2 !== undefined ?  this.selectedReason2 === x.Reson2.split('.')[x.Reson2.split('.').length - 1] && value.point.category === x.Reson3.split('.')[x.Reson3.split('.').length - 1] : value.point.category === x.Reson3.split('.')[x.Reson3.split('.').length - 1]) {
  //       if (!resMap.has(x.Fault))
  //         resMap.set(x.Fault, x.Value);
  //       else
  //         resMap.set(x.Fault, (x.Value + resMap.get(x.Fault)));
  //     }
  //   })
  //   resMap.forEach((value, key) => {
  //     data.push({
  //       name: key,
  //       value: value
  //     });
  //   })
  //   this.labelFault = [];
  //   this.dataFault = [];
  //   data?.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
  //   data?.forEach((e: any) => {
  //     this.labelFault.push(e.name.split('.')[e.name.split('.').length - 1]);
  //     this.dataFault.push(e.value);
  //   });
  //   this.drawDTFaultParetoAnalysis();
  //   this.isClickedReason3 = false;
  //   this.selectedReason3 = value.point.category;
  // }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions.api.sizeColumnsToFit();
  }

  clickedFault(value: any): void {
    this.faults = [];
    console.log(value.point.category);
    this.faultList.forEach((element) => {
      if (element.FaultDesc === value.point.category) {
        this.faults.push(element);
      }
    });
    this.rowData = this.faults;
  }
}
